// Angular
import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';

// NGRX
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';

import { take, filter, map } from 'rxjs/operators';

// OLCI
import * as fromRoot from '../reducers';
import * as olci from '../actions/olci';
import { constants } from '../constants/constants';
import { ContractsService } from '../modules/core/services/contracts.service';

export const biometricInfoResolver: ResolveFn<any> = (): Observable<any> | any => {
	const contractsService: ContractsService = inject(ContractsService);
	const store: Store<fromRoot.AppState> = inject(Store<fromRoot.AppState>);
    const router: Router = inject(Router);

	if (!contractsService.areAuthorizationsInTheStore) {
		const types = contractsService.contractsList;
		const payload = contractsService.getLoadCtcPayload(types);
		if (!(payload?.authorizedConsents?.length)) {
			router.navigate([constants.ROUTES.SELECT_GUESTS_FOR_CHECKIN]);
			return null;
		}
		const oldPayload = contractsService.geOldtLoadCtcPayload();
		store.dispatch(new olci.LoadCruiseContractAction(payload, oldPayload));
	}

	return store.pipe(
		select(fromRoot.getCruiseContractState),
		filter(cruiseContractState => cruiseContractState.loaded === true || cruiseContractState.error),
		take(1),
		map(res => {
			if (res.error) {
				store.dispatch(new olci.NavigateToError());
			}
			return res;
		})
	); 
}
